import { styled } from '@cp/ds/src/theme/styled';
import { Card } from 'src/shared/ui/card';

export const StyledCard = styled(Card)<{ viewed?: boolean }>(({ theme, viewed }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  ...(viewed && { opacity: 0.5 }),
}));
